export default __webpack_public_path__ + "static/media/1971.986f4ae4.png";